import React from 'react';

import { Flex, VStack } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { ResourceNotFound } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium, TextHeader2 } from 'uiToolkitV1/Typography';

export default function DataUnavailable({
  textAlign = 'center',
  align = 'center',
  height = '100%',
  message = 'Currently, no data present',
  className,
  style = {},
}) {
  return (
    <Flex width="100%" height={height} padding="5px">
      <Container align={align} textAlign={textAlign} height={height} className={className} style={style}>
        <VStack>
          <ResourceNotFound width="80px" height="80px" fill="none" />
          <TextHeader2 fontWeight="600">Sorry, We couldn’t find what you are looking for?</TextHeader2>
          <TextBodyMedium>Either it was moved, deleted, or no longer accessible.</TextBodyMedium>
        </VStack>
      </Container>
    </Flex>
  );
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: ${(props) => props.align};
  text-align: ${(props) => props.textAlign};
  border: 4px solid #ebeff3;
  border-radius: 8px;
`;
